import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Trophy } from 'lucide-react';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '@/components/ui/select';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from '@/components/ui/dialog';
import { toast } from 'sonner';

const ReportWinDialog = ({ open, onOpenChange, prefill = {} }) => {
  const [win, setWin] = useState({
    title: prefill.title || '',
    amount: prefill.amount || '',
    category: prefill.category || 'negotiation',
    description: prefill.description || '',
    source: prefill.source || '',
  });

  const handleSubmit = () => {
    if (!win.title || !win.amount) {
      toast.error('Please fill in title and savings amount');
      return;
    }
    toast.success('Savings reported to Team Savings!');
    onOpenChange(false);
    setWin({ title: '', amount: '', category: 'negotiation', description: '', source: '' });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Trophy className="h-5 w-5 text-green-600" />
            Report as Team Savings
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-3">
          <div>
            <Label>What did you achieve? *</Label>
            <Input value={win.title} onChange={(e) => setWin({...win, title: e.target.value})} placeholder="e.g., Switched to alternate for STM32" className="mt-1" />
          </div>
          <div>
            <Label>Savings Amount ($) *</Label>
            <Input type="number" value={win.amount} onChange={(e) => setWin({...win, amount: e.target.value})} placeholder="e.g., 5000" className="mt-1" />
          </div>
          <div>
            <Label>Category</Label>
            <Select value={win.category} onValueChange={(v) => setWin({...win, category: v})}>
              <SelectTrigger className="mt-1"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="negotiation">Negotiation</SelectItem>
                <SelectItem value="alternate">Alternate Part</SelectItem>
                <SelectItem value="distributor">Distributor Switch</SelectItem>
                <SelectItem value="volume">Volume Optimization</SelectItem>
                <SelectItem value="risk">Risk Mitigation</SelectItem>
                <SelectItem value="other">Other</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Notes (optional)</Label>
            <Textarea value={win.description} onChange={(e) => setWin({...win, description: e.target.value})} placeholder="Any additional details..." className="mt-1" rows={2} />
          </div>
          {prefill.source && (
            <p className="text-xs text-gray-500 bg-gray-50 p-2 rounded">Source: {prefill.source}</p>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={handleSubmit} className="bg-green-600 hover:bg-green-700 text-white" data-testid="report-win-submit">Report Savings</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export const ReportWinButton = ({ prefill = {}, size = 'sm' }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="ghost" size={size} className="text-green-600 hover:text-green-700 hover:bg-green-50" onClick={(e) => { e.stopPropagation(); setOpen(true); }} data-testid="report-win-btn">
        <Trophy className="h-3.5 w-3.5 mr-1" /> Report Win
      </Button>
      <ReportWinDialog open={open} onOpenChange={setOpen} prefill={prefill} />
    </>
  );
};

export default ReportWinDialog;
